import { render, staticRenderFns } from "./newSchemeDetailsTableSerious.vue?vue&type=template&id=fc19db64"
import script from "./newSchemeDetailsTableSerious.vue?vue&type=script&lang=js"
export * from "./newSchemeDetailsTableSerious.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports